<script setup lang="ts">
import { ref } from 'vue';

type VBtnVariant = 'flat' | 'text' | 'elevated' | 'tonal' | 'outlined' | 'plain' | undefined;

type Props = {
  cancel?: boolean;
  label?: string;
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  cancel: false,
});

const primaryBtnProps = ref({
  variant: 'flat' as VBtnVariant,
  color: 'primary',
});

const cancelBtnProps = ref({
  variant: 'plain' as VBtnVariant,
});
</script>

<template>
  <v-btn
    v-bind="props.cancel ? { ...cancelBtnProps, ...$attrs } : { ...primaryBtnProps, ...$attrs }"
    class="px-4"
    :class="{ 'text-decoration-underline': props.cancel }"
    :disabled="props.disabled"
  >
    <slot>{{ props.label }}</slot>
  </v-btn>
</template>
